<markant-dialog
  class="select-template-user-dialog"
  [open]="true"
  (close)="closeDialog()"
>
  @if (showResetConfirmationPrompt) {
    <h2 class="dialog-header">
      {{ translocoPath + 'reset' | transloco }}
    </h2>
    {{ translocoPath + 'resetHint' | transloco }}
    <div slot="markant-dialog-footer">
      <markant-button
        colorScheme="primary"
        variant="clear"
        (click)="closeDialog()"
      >
        {{ 'common.cancel' | transloco }}
      </markant-button>
      <markant-button
        class="confirm-button"
        colorScheme="primary"
        (click)="confirmResetConfiguration()"
      >
        {{ translocoPath + 'continue' | transloco }}
      </markant-button>
    </div>
  } @else {
    <h2 class="dialog-header">
      {{ translocoPath + 'headline' | transloco }}
    </h2>
    <div>
      {{ translocoPath + 'hint' | transloco }}
    </div>
    <h4>
      {{ translocoPath + 'availableEmployees' | transloco }}
    </h4>
    @if (tableParams$ | async; as tableParams) {
      <div class="select-template-user-table">
        <div class="toolbar">
          <markant-searchbar
            placeholder="{{
              'organization.users.searchPlaceholder' | transloco
            }}"
            [value]="tableParams.searchQuery"
            [debounce]="300"
            (valueChange)="onSearchChange($event.detail)"
          ></markant-searchbar>
        </div>
        <markant-platform-table
          [data]="tableData$ | async"
          [defaultHeaderCells]="tableDraft.headerAndTableCells"
          [loading]="(isLoading$ | async) ?? false"
          [totalCount]="totalCount"
          [pageSize]="tableParams.page.size"
          [pageIndex]="tableParams.page.index"
          (indexChanged)="onIndexChange($event)"
          (pageSizeChanged)="onPageSizeChange($event)"
          (sortChanged)="onSortChange($event)"
          (radioButtonSelected)="onSelectionChange($event)"
        >
        </markant-platform-table>
      </div>
    }
    <div slot="markant-dialog-footer">
      <markant-button
        colorScheme="primary"
        variant="clear"
        (click)="closeDialog()"
      >
        {{ 'common.cancel' | transloco }}
      </markant-button>
      <markant-button
        class="confirm-button"
        colorScheme="primary"
        (click)="confirmSelection()"
      >
        {{ 'common.confirm' | transloco }}
      </markant-button>
    </div>
  }
</markant-dialog>
